import { CheckboxOptionType } from 'antd';

export interface CommentTabs {
  title: string;
  type: CommentType;
  description?: string;
  options?: CheckboxOptionType[];
  imageUpload?: Boolean;
  imageDescription?: string;
  commentDescription?: string;
}

export enum CommentSide {
  WAREHOUSE = 'WAREHOUSE',
  SELLER = 'SELLER'
}

export enum CommentGroup {
  INBOUND_DETAIL = 'INBOUND_DETAIL',
  DELIVERY_DETAIL = 'DELIVERY_DETAIL',
  RETURN_DETAIL = 'RETURN_DETAIL',
  DISPOSAL_DETAIL = 'DISPOSAL_DETAIL',
  INQUIRY_DETAIL = 'INQUIRY_DETAIL'
}

export enum CommentStatus {
  REQUEST = 'REQUEST',
  REQUEST_DELETED = 'REQUEST_DELETED',
  APPROVE = 'APPROVE',
  COMPLETE = 'COMPLETE',
  REJECT = 'REJECT',
  EDITED = 'EDITED'
}

export interface Attachment {
  id: number;
  url: string;
  fileName: string;
}

export interface Comment {
  id: number;
  type: CommentType;
  group: CommentGroup;
  comment: string;
  createdAt: Date;
  side: CommentSide;
  status: CommentStatus;
  extraData?: string;
  attachments: Attachment[];
  disabled?: boolean;
}

export interface CommentForm {
  id?: number;
  reason?: string;
  comment: string;
  files?: File[];
}
export interface CreateComment {
  group: CommentGroup;
  type: CommentType;
  itemId: number;
  comment: string;
  extraData?: string;
  files?: File[];
  attachmentIds?: string;
}

export interface UpdateComment {
  comment: string;
  extraData?: string;
  attachmentIds?: string;
}

export interface CommentUpload {
  attachments?: File[];
  productImages?: File[];
}

export interface CommentListRequest {
  group: CommentGroup;
  itemId: number;
}

export interface CommentList {
  data: Comment[];
  // isAdding: Boolean;
  // isEditing: Boolean;
}

export interface CommentProps {
  itemId: number;
  commentGroup: CommentGroup;
  tabs: CommentTabs[];
  onSend: Function;
  commentList: CommentList;
  title?: string;
  refectComments?: Function;
  removeItem?: Function;
  removeTitle?: string;
  updateItem?: Function;
  disabled?: boolean;
  showAttachmentsDownload?: boolean;
  isWarehouseSendCommentFirst?: boolean;
  style?: React.CSSProperties;
  inspectionLabel?: string;
}

export enum CommentType {
  COMMON = 'COMMON',
  REQUEST_MODIFY = 'REQUEST_MODIFY',
  REQUEST_DELETE = 'REQUEST_DELETE',
  INSPECTION = 'INSPECTION'
}
